// src/pages/RealEstateAgent/NotificationPage.jsx
import React from "react";
import Layout from "../../layout/realestateagent/Layout";
import NotificationTile from "../../layout/realestateagent/Notification/NotificationTile";

const NotificationPage = () => {
    return (
        <Layout>
            <div className="container mx-auto">
                <NotificationTile />
            </div>
        </Layout>
    );
};

export default NotificationPage;
